import { configure } from "mobx";
import { createContext } from "react";
import { AlertStore } from "./alert";
import { DeleteStore } from "./delete";
import { ShipmentStore } from "./envio";
import { DestinoStore } from "./destino";
import { ProveedorStore } from "./proveedor";
import { UsuarioStore } from "./usuario";
import { PerfilStore } from "./perfil";
import { AuthStore } from "./auth";
import { ConfiguracionStore } from "./configuracion";
import { EmbarqueStore } from "./embarque";
import { CatalogoGeneralStore } from "./catalogoGeneral";
import { LogisticBackdropStore } from "./logisticBackdrop";
import { DialogConfirmacionStore } from "./dialogConfirmacion";

export class RootStore {
  logisticBackdropStore;
  alertStore;
  deleteStore;
  destinoStore;
  shipmentStore;
  proveedorStore;
  usuarioStore;
  perfilStore;
  authStore;
  configuracionStore;
  embarqueStore;
  catalogosStore;
  dialogConfirmacionStore;
  constructor() {
    this.logisticBackdropStore = new LogisticBackdropStore(this);
    this.alertStore = new AlertStore(this);
    this.deleteStore = new DeleteStore(this);
    this.destinoStore = new DestinoStore(this);
    this.shipmentStore = new ShipmentStore(this);
    this.proveedorStore = new ProveedorStore(this);
    this.usuarioStore = new UsuarioStore(this);
    this.perfilStore = new PerfilStore(this);
    this.authStore = new AuthStore(this);
    this.configuracionStore = new ConfiguracionStore(this);
    this.embarqueStore = new EmbarqueStore(this)
    this.catalogosStore = new CatalogoGeneralStore(this);
    this.dialogConfirmacionStore = new DialogConfirmacionStore(this)
  }
}
export const RootStoreContext = createContext(new RootStore());
